import { useNavigate } from 'react-router'
import { useState } from 'react'
import { LoginExtranetForm } from './components'
import useAuthExtranet from '../../hooks/useAuthExtranet'

export default function LoginExtranet() {
  const { setAuth } = useAuthExtranet()
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const onError = (error) => {
    setError(error)
  }

  const onSuccess = (response) => {
    if (response.accessToken) {
      setAuth({
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
      })
      navigate('/ext_coproprietaires', { replace: true })
    }
  }
  return (
    <LoginExtranetForm onError={onError} onSuccess={onSuccess} error={error} />
  )
}
